module.exports = __webpack_public_path__ + "static/img/bgs2.7bc05bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/bgs2.jpg
// module id = Suxg
// module chunks = 1